<app-header></app-header>
<div class="our_team">
  <!-- Top Section with Heading and Subheading -->
  <div class="our_team_top text-center bg_1">
    <ng-container *ngFor="let heading of head">
      <div class="inline_padding2" *ngIf="heading.page === currentPage">
        <div>
          <span class="text_style_5">Our Clients</span>
        </div>
        <p>We are proud to collaborate with some of the largest and most respected organizations in the Pharmaceutical,
          Veterinary, Agrochemical, Specialty Chemical, and Fine Chemical industries, as well as in the broader sciences
          sector. Our commitment is to deliver exceptional results for our clients, ensuring the success of the
          campaigns we manage for CMOs, CROs, ingredient suppliers, and processing companies. We take great pride in the
          strong relationships we've built with leading organizations across these industries. Our diverse client base
          includes large private corporations, public sector entities, and small-to-medium enterprises from various
          sectors, including Manufacturing, Trading & Consulting Companies, and many others.</p>
        <div class="p-top-16">
          <span [innerHtml]="heading.page_sub_heading"></span>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Client Cards Section -->
  <div class="our_team_content bottom_padding1">
    <ng-container *ngFor="let client of clients; let i = index">

      <!-- Card 1 for Even Indexed Clients -->
      <div class="our_team_content_card1 bg_2 inline_padding1" *ngIf="i % 2 === 0">
        <div class="our_team_content_card1_img">
          <img class="our_team_content_card1_img_profile border-radius-20" [src]="imageBaseUrl + client.logo"
            width="100%">
        </div>
        <div class="our_team_content_card1_body">
          <div class="our_team_content_card1_body_data">
            <div>
              <span class="text_black_7" [innerHtml]="client.title"></span>
            </div>
            <div class="p-top-16">
              <span class="text_blue_7" [innerHtml]="client.sub_title"></span>
            </div>

            <div [ngClass]="{ 'text_lines_6': !showMore[i], 'p-top-16': true }" [innerHtml]="client.description"
              class="text-wrap ql-editor description-wrapper"></div>
            <!-- Show "Read More" only if the content is long enough -->
            <!-- Show "Read More" only if the content is long enough -->
            <div class="cursor-pointer p-top-16" *ngIf="shouldShowMore[i]">
              <span class="text_blue_14" (click)="toggleShowMore(i)">
                {{ showMore[i] ? 'Read Less' : 'Read More' }}
              </span>
            </div>
            <div *ngIf="client.web_link" class="p-top-12">
              <button type="button" class="rounded-pill text_white_1 button_blue_7"
                (click)="openLink(client.web_link)"><span class="button_blue_1_text"> Weblink</span> <img
                  class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></button>
            </div>
            <div class="share-buttons" style="margin-top:15px;">
              <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
              </button>
              <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
              </button>
              <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
              </button>
              <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
              </button>
              <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
              </button>
              <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
              </button>
              <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
              </button>
              <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
              </button>
              <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
              </button>
              <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
              </button>
              <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
              </button>
              <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
              </button>
              <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
              </button>
              <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
              </button>
              <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
              </button>
              <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
              </button>
              <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
              </button>

            </div>
          </div>
        </div>
      </div>

      <!-- Card 2 for Odd Indexed Clients -->
      <div class="our_team_content_card2 bg_1 inline_padding1" *ngIf="i % 2 !== 0">
        <div class="our_team_content_card2_body1">
          <div class="our_team_content_card2_img1">
            <img [src]="imageBaseUrl + client.logo" class="img-fluid border-radius-20 our_teams_content_card2_img1">
          </div>
          <div class="our_team_content_card2_body1_data1">
            <div>
              <span class="text_black_7" [innerHtml]="client.title"></span>
            </div>
            <div class="p-top-16">
              <span class="text_blue_7" [innerHtml]="client.sub_title"></span>
            </div>



            <div [ngClass]="{ 'text_lines_6': !showMore[i], 'p-top-16': true }" [innerHtml]="client.description"
              class="text-wrap ql-editor description-wrapper"></div>


            <!-- Show "Read More" only if the content is long enough -->
            <!-- Show "Read More" only if the content is long enough -->
            <div class="cursor-pointer p-top-16" *ngIf="shouldShowMore[i]">
              <span class="text_blue_14" (click)="toggleShowMore(i)">
                {{ showMore[i] ? 'Read Less' : 'Read More' }}
              </span>
            </div>
            <div *ngIf="client.web_link">

              <div *ngIf="client.web_link" class="p-top-12">
                <button type="button" class="rounded-pill text_white_1 button_blue_7"
                  (click)="openLink(client.web_link)"><span class="button_blue_1_text"> Weblink</span> <img
                    class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></button>
              </div>
            </div>
            <div class="share-buttons" style="margin-top:15px;">
              <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
              </button>
              <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
              </button>
              <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
              </button>
              <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
              </button>
              <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
              </button>
              <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
              </button>
              <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
              </button>
              <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
              </button>
              <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
              </button>
              <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
              </button>
              <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
              </button>
              <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
              </button>
              <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
              </button>
              <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
              </button>
              <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
              </button>
              <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
              </button>
              <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
                <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
              </button>

            </div>
          </div>
        </div>
        <div class="our_team_content_card2_img">
          <img [src]="imageBaseUrl + client.logo" class="img-fluid border-radius-20 our_team_content_card2_img_profile">
        </div>
      </div>

    </ng-container>
  </div>


</div>
<app-footer></app-footer>